import(/* webpackMode: "eager" */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/src/app/(public)/[orgName]/search/page.tsx");
